module.exports = __webpack_public_path__ + "img/icon-arrow-down.asset.2cd6915c.svg";